import React from "react";
import localization from '../../../../data/config';
import ResetTable from '../../ResetTable';
import MediaQuery from "react-responsive";
import breakpoints from "../../../../constants/breakpoints";
import "./style.css";

/**
 * @name NoData
 * @function
 * @description Displays noDataLabel When no results found.
 * @returns {JSX}
 */
const NoData = () => {
  return (
    <>
    <MediaQuery minDeviceWidth={breakpoints.laptop.min}>
    <div role="alert" className="no-results__container">
      <div className="no-data__content">
        <p className="no-results">
          {localization.noDataLabel}
        </p>
        <ResetTable/>
      </div>
    </div>
    </MediaQuery>
    <MediaQuery maxDeviceWidth={breakpoints.mobile.max}>
      <div role="alert" className="no-results__container-mobile">
      <div className="no-data__content">
        <p className="no-results">
          {localization.noDataLabel}
        </p>
        <ResetTable/>
      </div>
    </div>
    </MediaQuery>
    </>
  );
};

export default NoData;
